module.exports = __webpack_public_path__ + "static/media/red-close.fc064204.svg";